import { Component } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';

@Component({
  imports: [MatCard, MatCardContent, MatDivider, MatCardTitle, MatCardHeader],
  selector: 'app-typography',
  styleUrl: './typography.component.scss',
  templateUrl: './typography.component.html',
})
export class TypographyComponent {}
